<p-blockUI [blocked]="blocked">
  <div id="center" style="margin-top:260px; margin-left:800px;">
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>

<div class="container-fluid mt-0">
  <p-confirmDialog class="confirm-message" appendTo="body"></p-confirmDialog>
  <p-confirmDialog key="warningForChange" appendTo="body" [closable]="false"></p-confirmDialog>
  <div class="row">
    <div class="col-12 flex p-0">
      <div class="col-3">
        <div class="row m-0 p-0">
          <div class="col-11" id="multiselectDiv">
            <div class="ui-inputgroup mb-0" id="filterLabel">
              <button pButton class="theme-button noHover labelButton" type="button" label="Filter"></button>
              <p-multiSelect [options]="filterOptions" (onChange)="onApplyFilter()" [(ngModel)]="selectedStates"
                id="multiselectStatuses" placeholder="Sel. Status" [maxSelectedLabels]="1" styleClass="multiSelectionDropdown">
                <ng-template let-item pTemplate="selectedItem">
                  <span style="vertical-align:middle">{{item.label}}</span>
                </ng-template>
                <ng-template let-status pTemplate="item">
                  {{status.label}}
                </ng-template>
              </p-multiSelect>
            </div>
          </div>

          <div class="col-1" id="refreshBatchesDiv">
            <button pButton class="refreshBatches" icon="fa fa-refresh" (click)="reloadRuns()"></button>
          </div>
        </div>
        <div class="row m-0 p-0">
          <div class="col-6 p-0">
            <p-calendar [(ngModel)]="fromDate" readonlyInput="true" (onSelect)="onApplyFilter()"
              [inputStyle]="{'width':'70%','height':'100%'}" dateFormat="dd.mm.yy" [showIcon]="true"
              placeholder="From" showButtonBar="true" [maxDate]="toDate"></p-calendar>
          </div>
          <div class="col-6 p-0">
            <p-calendar [(ngModel)]="toDate" [minDate]="fromDate" readonlyInput="true"
              (onSelect)="onApplyFilter()" [inputStyle]="{'width':'70%','height':'100%'}" dateFormat="dd.mm.yy"
              [showIcon]="true" placeholder="To" showButtonBar="true"></p-calendar>
          </div>
        </div>
        <div class="row m-0 p-0">
          <label class="m-0">
            Number Of Batches Matching Filter: <label class="m-0 font-weight-bold text-success" style="font-size: 1.2rem;">{{runProcesses == null ? 0: runProcesses.length}} </label>
          </label>
        </div>
      </div>
      <div class="col-9">
        <div class="col-12 flex" id="topGroup">
          <div class="col-4 topDivspacing pr-0" id="topDiv">
            <div class="ui-inputgroup" id="inputClass">
              <button pButton class="theme-button noHover labelButton" type="button" label="User ID"></button>
              <input pInputText name="UserPUID" [(ngModel)]="puid" size="10" id="userID" id="puid-field" class="inputFileds"/>
              <button pButton class="search-field-blue-end"></button>
            </div>
            <div class="ui-inputgroup" id="inputClass" value="enabeledd">
              <button pButton class="theme-button noHover labelButton" type="button" label="Run ID"></button>
              <input pInputText name="SearchRun" [(ngModel)]="valueToSearch" size="10"
                (keydown.enter)="searchForRunWIthFilter()" class="inputFileds"/>
              <button pButton class="search-field-blue-end" icon="fa fa-search" (click)="searchForRunWIthFilter()"></button>
            </div>
          </div>
          <div class="col-5 topDivspacing pr-0 pl-0" style="text-align:left;">
            <div *ngIf="!showPlateView" class="col-12 headers">
              <h5>
                Run: <strong style="margin: 3%;">{{selectedRun?.runId}}</strong>
              </h5>
            </div>
            <div *ngIf="showPlateView" class="col-12 headers">
              <h5>
                Sequencer Type : <strong style="margin: 3%;">{{selectedRun?.sequencerType}} </strong>
              </h5>
            </div>
            <div *ngIf="showPlateView" class="col-12 headers"id="headerNonTop">
              <h5>
                Flowcell : <strong style="margin: 3%;">{{selectedRun?.flowCellName}} </strong>
              </h5>
            </div>
            <div *ngIf="showPlateView" class="col-12 headers"id="headerNonTop">
              <h5>
                Read Mode : <strong style="margin: 3%;">{{selectedRun?.largestReadMode}} </strong>
              </h5>
            </div>
            <div *ngIf="showPlateView" class="col-12 headers"id="headerNonTop">
              <h5>
                Machine : <strong style="margin: 3%;">{{selectedRun?.sequencerIntrument}} </strong>
              </h5>
            </div>
            <div *ngIf="showPlateView" class="col-12 headers"id="headerNonTop">
              <h5>
                Start Date (Planned) : <strong style="margin: 3%;">{{selectedRun?.planDate | date: 'dd.MM.yy HH:mm'}} </strong>
              </h5>
            </div>
            <div class="col-12 headers" id="headerNonTop">
              <h5>
                Status: <strong style="margin: 3%;">{{selectedRun?.status}} </strong>
              </h5>
            </div>
          </div>
          <div class="col-3 topDivspacing p-0">
            <div class="col-12 p-0">
              <button pButton [icon]="getViewPlateIcon(showPlateView)" [label]="getPlateViewButtonLabel(showPlateView)"
              [ngStyle]="buttonsRound" id="plateView" (click)="togglePlateView()"
                [disabled]="!selectedRun?.runId"></button>
            </div>
            <div class="col-12 p-0" *ngIf="showPlateView">
              <div class="col-6 p-0">
                <p-dropdown name="runAction" [style]="{'width':'100%'}" [options]="actionOptions" [(ngModel)]="runActionSelection" placeholder="Select Action"></p-dropdown>
              </div>
              <div class="col-4 p-0">
                <button pButton class="goButton" type="button" label="Go" [disabled]="!runActionSelection" (click)="showRemovalSideBar()"></button>
              </div>
            </div>
            <div class="col-12 p-0">
              <button pButton class="goButton" pButton icon="fa fa-comment" type="button" label="Comments" (click)="showRemovalSideBar()"></button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 flex p-0">
      <div class="col-3 tableLHS1">
        <p-table [value]="runProcesses" selectionMode="single"
          (onRowSelect)="runViewVisbility($event)" (onRowUnselect)="removeRunSelection()" [loading]="loading">
          <ng-template pTemplate="header">
            <tr>
              <th scope="col" style="width: 40%;" class="batch">Run ID</th>
              <th scope="col" class="status">Status</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-run>
            <tr [pSelectableRow]="run">
              <td style="width: 40%;"
                [class]="(run?.rushSample == true) ? 'rushBody pr-0': 'normalBody pr-0'">
                {{run?.runId}}</td>
              <td [class]="(run?.rushSample == true) ? 'rushBody pr-0': 'normalBody pr-0'">
                {{run?.status}}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <div class="col-9">
        <div class="col-12" id="tableDiv" [hidden]="showPlateView">
          <table aria-describedby="Processing table" id="processingTable"
            style="border: 1px solid black; width: 100%; height: 100%; table-layout: fixed;">
            <thead id="processingTableHeader">
              <tr>
                <th colspan="2"> Run Information</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="run-info-labels-left" style="color:#1F89CE; font-size: 19px; width: 200px; padding-left: 30px; padding-top: 15px"> Sequencer Type : <strong>{{selectedRun?.sequencerType}}</strong>  </td>
                <td class="run-info-labels-right" style="color:#1F89CE; font-size: 19px; width: 200px; padding-top: 15px"> Machine : <strong>{{selectedRun?.sequencerIntrument}}</strong>  </td>
              </tr>
              <tr>
                <td class="run-info-labels-left" style="color:#1F89CE; font-size: 19px; width: 200px; padding-left: 30px;padding-top: 15px"> Flowcell : <strong>{{selectedRun?.flowCellName}}</strong>  </td>
                <td class="run-info-labels-right" style="color:#1F89CE; font-size: 19px; width: 200px;padding-top: 15px"> Read Mode : <strong>{{selectedRun?.largestReadMode}}</strong>  </td>
              </tr>
              <tr>
                <td class="run-info-labels-left" style="padding-bottom: 15px"> Start Date (Planned) : <strong>{{selectedRun?.planDate | date: 'dd.MM.yy HH:mm'}}</strong>  </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-12" id="tableDiv" [hidden]="showPlateView">
          <table aria-describedby="Processing table" id="processingTable"
            style="border: 1px solid black; width: 100%; height: 100%; table-layout: fixed;">
            <thead id="processingTableHeader">
              <tr>
                <th scope="col">Run Preparation</th>
                <th scope="col">Sequencing Run</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody class="processingTableBody">
              <tr>
                <td class="processingTableBody">
                  <div class="col-12 parent">
                    <div class="col-8 child">
                      <button pButton label="Sequencing Run Planned" class="buttonsRound startButton" [disabled]="true"></button>
                    </div>
                    <div class="col-4 sibling">
                      {{selectedRun?.creationDate | date: 'dd.MM.yy HH:mm'}} <br />
                      {{selectedRun?.runPlannedPuid}}
                    </div>
                  </div>
                  <div class="col-12 parent">
                    <div class="col-8 child">
                      <button pButton label="Start Dilution and Pooling" (click)="saveRunStatus('DIL_AND_POOL_STARTED')"
                      [disabled]="disableStartDilutionAndPoolingButton() || startDilAndPoolPresent()" class="buttonsRound startButton"></button>
                    </div>
                    <div class="col-4 sibling">
                      {{selectedRun?.dilutionAndPoolingStartedDateTime | date: 'dd.MM.yy HH:mm'}} <br />
                      {{selectedRun?.dilutionAndPoolingStartedPUID}}
                    </div>
                  </div>
                  <div class="col-12 parent">
                    <div class="col-8 child">
                      <button pButton label="D & P Workfile" (click)="downloadDilutionPoolingWorkFile('DNP_WORKFILE')"
                      [disabled]="disableButtonIfRunNotSelected() || disableDNPWorkfile() || completeDilAndPoolPresent()" class="buttonsRound dnpWorkfile"></button>
                    </div>
                    <div class="col-4 sibling">
                      {{selectedRun?.dnpWorkfileDateTime | date: 'dd.MM.yy HH:mm'}} <br />
                      {{selectedRun?.dnpWorkfilePUID}}
                    </div>
                  </div>
                  <div class="col-12 parent">
                    <div class="col-8 child">
                      <button pButton [disabled]="disableButtonIfRunNotSelected() || disableCompleteDilAndPool() || completeDilAndPoolPresent()" label="Complete Dilution and Pooling" (click)="saveRunStatus('DIL_AND_POOL_FINISHED')" class="buttonsRound backgroundOrange"></button>
                    </div>
                    <div class="col-4 sibling">
                      {{selectedRun?.dilutionAndPoolingFinishedDateTime | date: 'dd.MM.yy HH:mm'}} <br />
                      {{selectedRun?.dilutionAndPoolingFinishedPUID}}  
                    </div>
                  </div>
                </td>
                <td class="processingTableBody">
                  <div class="col-12 parent">
                    <div class="col-8 child">
                      <button pButton label="Sequencer Sample Sheet" (click)="downloadSampleSheetWorkFile('DIL_AND_POOL_FINISHED')"
                        class="buttonsRound dnpWorkfile"
                        [disabled]="disableButtonIfRunNotSelected() || disableSeqRunStarted()"></button>
                    </div>
                  </div>
                  <div class="col-12 parent">
                    <div class="col-8 child">
                      <button pButton [disabled]="disableButtonIfRunNotSelected() || disableSeqRunStarted() || seqRunStartedPresent()" label="Sequencing Run Started" class="buttonsRound startButton" (click)="saveRunStatus('SEQ_RUN_STARTED')"></button>
                    </div>
                    <div class="col-4 sibling">
                      {{selectedRun?.sequencingRunStartedDate | date: 'dd.MM.yy HH:mm'}} <br />
                      {{selectedRun?.sequencingRunStartedPUID}}
                    </div>
                  </div>

                  <div class="col-12 parent">
                    <div class="col-8 child">
                      <button pButton [disabled]="disableButtonIfRunNotSelected() || disableSeqRunFinished() || seqRunFinishedPresent()" label="Sequencing Run Completed" (click)="showRunCompletionSidebar()" class="buttonsRound backgroundOrange"></button>
                    </div>
                    <div class="col-4 sibling">
                      {{selectedRun?.sequencingRunFinishedDateTime | date: 'dd.MM.yy HH:mm'}} <br />
                      {{selectedRun?.sequencingRunFinishedPUID}}
                    </div>
                  </div>

                  <div class="col-12 parent">
                    <p style="margin:2%;"><u>Upload Run Feedback File:</u></p>
                    <div class="col-12 flex p-0 ui-inputgroup">
                        <input #runFeedbackFileInput pInputText class="form-control" name="profile" type="file" [disabled]="disableButtonIfRunNotSelected() || disableRunFeedbackReceived() || runFeedbackReceivedPresent()"
                        accept=".json" (change)="onFileSelect($event)" placeholder="Upload Run Feedback File"/>
                        <button pButton icon="fa fa-upload" type="submit" id="uploadButtonExcel"
                        (click)="fileUpload(runFeedbackFileInput)"  class="uploadBtn" [disabled]="isRunFeedbackFileNotSelected || disableButtonIfRunNotSelected() || disableRunFeedbackReceived() || runFeedbackReceivedPresent()">
                        </button>
                    </div>
                  </div>

                  <div class="col-12 parent">
                    <div class="col-8 child">
                      <button pButton [disabled]="disableButtonIfRunNotSelected() || disableRunFeedbackReceived() || runFeedbackReceivedPresent()" label="Run Feedback Received" (click)="saveRunStatus('RUN_FEEDBACK_RECEIVED')" class="buttonsRound thirdButton"></button>
                    </div>
                    <div class="col-4 sibling">
                      {{selectedRun?.runFeedbackReceivedDateTime | date: 'dd.MM.yy HH:mm'}} <br />
                      {{selectedRun?.runFeedbackReceivedPUID}}
                    </div>
                  </div>

                  <div class="col-12 parent">
                    <div class="col-8 child">
                      <button pButton [disabled]="disableButtonIfRunNotSelected() || disableRunCompleted() || disableIfReRunRun()" label="Complete Run" (click)="saveRunStatus('RUN_COMPLETED')" class="buttonsRound backgroundOrange"></button>
                    </div>
                    <div class="col-4 sibling">
                      {{selectedRun?.completionDateTime | date: 'dd.MM.yy HH:mm'}} <br />
                      {{selectedRun?.completionPUID}}
                    </div>
                  </div>
                </td>

                <td class="processingTableBody">
                  <div class="col-12 parent">
                    <div class="col-8 child">
                      <button pButton [disabled]="true" label="Re-Run Sequencing Run" (click)="commentPopup=true" class="buttonsRound reRunSequence"></button>
                      <!-- Conditions to be add once re-run sequencing run functionality is decided: "disableButtonIfRunNotSelected() || disableReRunSeq()" -->
                    </div>
                    <div class="col-4 sibling">
                      {{selectedRun?.reRunSeqRunDateTime | date: 'dd.MM.yy HH:mm'}} <br />
                      {{selectedRun?.reRunSeqRunPUID}}
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-12 laneContainer laneContainerPaddingTop" *ngIf="showPlateView">
          <p-table [value]="laneViewList" [columns]="scrollableColsforLanelist" dataKey="laneId"
            rowExpandMode="single"  expandableRows="true" (onRowExpand)="onRowExpand($event)" (onRowCollapse)="onRowClose($event)">
            <ng-template pTemplate="body" let-rowData let-expanded="expanded" let-columns="columns">

              <tr [pSelectableRow]="rowData" style="border: 1px solid #1F89CE;">
                <ng-container *ngFor="let col of columns">
                  <td *ngIf="col.field =='laneId'" style="width: 9.92%;border: 0px;background-color: white;"
                    class="text-center">
                    {{rowData[col.field]}}
                  </td>
                  <td *ngIf="col.field =='dueDate'" style="width: 38.2%;border: 0px;background-color: white;">
                    <div class="col-12 p-0 laneBlockContainer lane">
                      <div *ngFor="let laneValue of getLaneBlocks(rowData.laneId)" style="display: inline-block;"
                        class="laneBlock" [ngStyle]="getLaneBlockStyle(laneValue)">
                      </div>
                    </div>
                  </td>
                  <td *ngIf="col.field =='constraintId'" style="width: 13.25%;border: 0px;background-color: white;"
                    class="text-center">
                    {{rowData[col.field]}}
                  </td>
                  <td *ngIf="col.field =='totalLibIds' && !expanded" style="width: 10.25%;border: 0px;background-color: white;"
                    class="text-center">
                    {{rowData[col.field]}} ({{getSelectLibCountForLane(rowData['laneId'])}})
                  </td>
                  <td *ngIf="col.field =='totalLibIds' && expanded" style="width: 10.25%;border: 0px;background-color: white;"
                    class="text-center">
                    {{rowData[col.field]}}
                  </td>
                  <td *ngIf="col.field =='totalReadsCount'" style="width: 13.3%;border: 0px;background-color: white;"
                    class="text-center">
                    {{rowData[col.field]}}
                  </td>
                  <td *ngIf="col.field =='phixPercentage'" style="width: 10.2%;border: 0px;background-color: white;"
                    class="text-center">
                    {{rowData[col.field]}} %
                  </td>
                  <td *ngIf="col.field =='rowExpand'" style="text-align: center;border: 0px;background-color: white;">
                    <div [pRowToggler]="rowData">
                      <em [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></em>
                    </div>
                  </td>

                </ng-container>
              </tr>
            </ng-template>
            <ng-template pTemplate="rowexpansion" let-rowData>
              <tr class="bg-white">
                <p-table
                  [style]="{width: '1008%','border': '1px solid #0072bc'}"
                  [value]="libraryIdTabledata" dataKey="libraryId" [columns]="scrollableColsforLibData"
                  [scrollable]="true" [loading]="loading" [(selection)]="librarySelectionList" [metaKeySelection]="true"
                  selectionMode="multiple" (sortFunction)="customSort($event)" [customSort]="true" sortField="libraryId" [sortOrder]="1">
                  <br /><br />
                  <ng-template pTemplate="caption">
                    <table style="border: none;" aria-describedby="table to format">
                      <thead>
                        <th class="text-left">
                          <label>Displayed Libs (Total Libs) : {{getRowsCount()}} ({{getTotalLibsCount(rowData)}})</label>
                        </th>
                        <th class="text-center">
                          <label>Selected Libs : {{getSelectLibCount()}}</label>
                        </th>
                        <th class="text-right">
                          <em class="fa fa-search"></em>
                          <input type="text" pInputText size="40" placeholder="Global Filter"
                            (input)="globalfilterLibrayTable($event.target.value, rowData)" style="width:auto"  [(ngModel)]="laneLibFilterValue">
                        </th>
                      </thead>
                    </table>
                  </ng-template>
                  <ng-template pTemplate="header">
                    <tr>
                      <th scope="col" style="width: 2.25em"></th>
                      <th scope="col" class="text-center" pSortableColumn="libraryId">Library ID <p-sortIcon
                          field="libraryId"> </p-sortIcon>
                      </th>
                      <th scope="col" class="text-center" pSortableColumn="projectName">Project <p-sortIcon
                          field="projectName"> </p-sortIcon>
                      </th>
                      <th scope="col" class="text-center" pSortableColumn="sampleName">Sample <p-sortIcon
                          field="sampleName"> </p-sortIcon>
                      </th>
                      <th scope="col" class="text-center" pSortableColumn="missingReads">Planned Reads <p-sortIcon
                          field="missingReads"> </p-sortIcon>
                      </th>
                      <th scope="col" class="text-center" pSortableColumn="status">Status <p-sortIcon
                          field="status"> </p-sortIcon>
                      </th>
                      <th scope="col" class="text-center" pSortableColumn="tagInfo">Tag <p-sortIcon
                          field="tagInfo"> </p-sortIcon>
                      </th>
                      <th scope="col" class="text-center" pSortableColumn="plateID">Plate-ID
                        <p-sortIcon field="plateID"> </p-sortIcon>
                      </th>
                      <th scope="col" class="text-center" pSortableColumn="position">Position
                        <p-sortIcon field="position"> </p-sortIcon>
                      </th>
                      <th scope="col" class="text-center" pSortableColumn="dueDate">Due date 
                        <p-sortIcon field="dueDate"> </p-sortIcon>
                      </th>
                      <th scope="col" class="text-center" style="width: 3em">
                        <p-tableHeaderCheckbox ></p-tableHeaderCheckbox>
                      </th>
                    </tr>
                  </ng-template>

                  <ng-template pTemplate="body" let-library let-expanded="expanded" let-columns="columns" let-rowIndex="rowIndex">
                    <tr [pSelectableRow]="library" [pSelectableRowIndex]="rowIndex">
                      <td *ngIf="isLibraryContainer(library)" style="width: 2.25em">
                        <div [pRowToggler]="library">
                          <em [ngClass]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></em>
                        </div>
                      </td>
                      <td *ngIf="!isLibraryContainer(library)" style="width: 2.25em"></td>
                      <ng-container *ngFor="let col of columns">
                        <td *ngIf="col.field != 'missingReads' && col.field != 'dueDate' && col.field != 'tagInfo' && col.field != 'status'"
                          class="text-center word-wrap">
                          {{getValueforLib(col.field, library)}}
                        </td>
                        <td *ngIf="col.field == 'status'" class="text-center word-wrap">
                          {{library[col.field]}}
                        </td>
                        <td *ngIf="col.field == 'missingReads'" class="text-center word-wrap">
                          {{abbreviateNumber(library[col.field])}}
                        </td>
                        <td *ngIf="col.field == 'dueDate'" class="text-center word-wrap ">
                          {{library[col.field] | date: dateFormat}}
                        </td>
                        <td *ngIf="col.field == 'tagInfo'" class="text-center word-wrap">
                          {{library[col.field][0].tagManufacturerindex}}<br> {{library[col.field][0].tagSequence}}
                        </td>
                      </ng-container>
                      <td style="width: 3em">
                      </td>
                    </tr>
                  </ng-template>

                  <ng-template pTemplate="rowexpansion" let-containerLib let-columns="columns">
                    <tr>
                      <td class="p-0" [attr.colspan]="columns.length + 2">
                        <p-table [value]="getContainerLibraries(containerLib['libraryId'])">
                          <ng-template pTemplate="body" let-containedLib>
                            <tr style="color: #0e56f0;">
                              <td style="width: 2.25em"></td>
                              <ng-container *ngFor="let col of columns">
                                <td *ngIf="col.field != 'missingReads' && col.field != 'dueDate' && col.field != 'tagInfo'"
                                  class="text-center ">
                                  {{getValueforLib(col.field, containedLib)}}
                                </td>
                                <td *ngIf="col.field == 'missingReads'" class="text-center ">
                                  {{abbreviateNumber(containedLib[col.field])}}
                                </td>
                                <td *ngIf="col.field == 'dueDate'" class="text-center ">
                                  {{containedLib[col.field] | date: dateFormat}}
                                </td>
                                <td *ngIf="col.field == 'tagInfo'" class="text-center ">
                                  {{containedLib[col.field][0].tagManufacturerindex}}<br> {{containedLib[col.field][0].tagSequence}}
                                </td>
                              </ng-container>
                              <td style="width: 3em"></td>
                            </tr>
                          </ng-template>
                        </p-table>
                      </td>
                    </tr>
                  </ng-template>

                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td [attr.colspan]="7" class="text-center">
                        No records found
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="footer"> 
                    <table style="border: none;" aria-describedby="table to format">
                    <thead>
                      <th style="text-align: center;">
                        <button pButton label="More" icon="pi pi-arrow-down" [disabled]="isMoreButtonDisabled(rowData)" (click)="moreToshow(rowData)"></button>
                      </th>
                    </thead>
                  </table> 
                </ng-template>
              </p-table>
            <br /><br />
          </tr>
          </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog header="Comments" [(visible)]="showCommentDialog" [modal]="true" position="top" [dismissableMask]="true"
  (onHide)="clearComment()">
  <div class="border border-info" id="commentShowDiv">

    <div >
      <div class="col-12  p-0 commentBubbleSection" style="height: 100%; ">

        <div class="col-12 commentPUIDDate">
          <label class="m-0"></label>
        </div>

        <div
          class="col-12 commentPUIDDate font-weight-bold">

          <a href="javascript:void(0);" (click)="downloadTemplate($event)"></a>
          has been downloaded.
        </div>

        <div
          class="col-12 commentPUIDDate font-weight-bold">

          <a href="javascript:void(0);" (click)="downloadTemplate($event)"></a>

        </div>

        <div
          class="col-12 commentPUIDDate font-weight-bold">
          <a href="javascript:void(0);" (click)="downloadTemplate($event)"></a>

        </div>


        <div
          class="col-12 commentPUIDDate font-weight-bold">
          <a href="javascript:void(0);" (click)="downloadTemplate($event)"></a>

        </div>

        <div class="col-12 commentPUIDDate font-weight-bold">
         <a class="text-primary" style="text-decoration:underline" ></a>
        </div>

        <div  class="col-12 pt-0 pb-0 commentPUIDDate font-weight-bold">
          <p></p>
        </div>

      </div>
    </div>
  </div>
  <div id="commentTextAreDiv">
    <textarea pInputTextarea class="commentTextArea" placeholder="Add new comment here..."
      ></textarea>
  </div>
  <p-footer>
    <button pButton label="Add Comment"  (click)="saveComment()"></button>
  </p-footer>
</p-dialog>

<p-dialog header="Missing Reads Overview" [style.width]="'600px'" [(visible)]="showFeedbackDialog" [modal]="true" position="top" [dismissableMask]="true">
  <div class="missing-reads-dialog">
    <p-table [value]="libraryData" selectionMode="none" [scrollable]="false">
      <ng-template pTemplate="header">
        <tr>
          <th scope="col">Library ID</th>
          <th scope="col">Achieved Reads</th>
          <th scope="col">Missing Reads</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-library>
        <tr>
          <td [class]="(library.missingReads > 0) ? 'missingReadsPos pr-0': 'missingReadsNeg pr-0'">
            {{library.libraryId}}</td>
          <td [class]="(library.missingReads > 0) ? 'missingReadsPos pr-0': 'missingReadsNeg pr-0'">
            {{library.achievedReads}}</td>
          <td [class]="(library.missingReads > 0) ? 'missingReadsPos pr-0': 'missingReadsNeg pr-0'">
            {{library.missingReads}}</td>
        </tr>
      </ng-template>
    </p-table>
    <div class="row m-0 mt-2">
      <div class="col-6 text-center">
        <button pButton [ngStyle]="buttonsRound" (click)="saveRunStatus('RERUN_RUN')" class="reRunSequence" label="Redo Complete Run"></button>
      </div>
      <div class="col-2"></div>
      <div class="col-4 text-center">
        <button pButton [ngStyle]="buttonsRound" (click)="saveRunStatus('RUN_COMPLETED')" class="startButton" label="Complete Run"></button>
      </div>
    </div>
  </div>
</p-dialog>


<p-dialog header="Confirmation" [(visible)]="commentPopup" [modal]="true" [dismissableMask]="true">
  <label class="font-weight-bold">Select appropriate option to proceed: </label>

  <p-footer>
    <button pButton class="bg-success" label="QC OK -> Continue" (click)="saveRunStatus('COMPLETED')"></button>
    <button pButton class="bg-danger" label="QC Failed" (click)="saveRunStatus('REDO')"></button>

  </p-footer>
</p-dialog>

<p-sidebar [(visible)]="showRemoveLibsSideBar" position="right" [baseZIndex]="10000" 
  [dismissible]="true" [modal]="true" [style]="{'width':'45em', 'word-wrap': 'break-word'}">
  <div class="col-12 text-left" style="width: 100%; color: white; background-color: #006B96;">
    <label class="font-weight-bold" style="font-size: x-large; margin-bottom: 0;">
      Remove Libraries
    </label>
  </div>

  <div *ngIf="removalEmptyLibsMessage" class="col-12 text-center" style="font-size: large; color: red;">
    {{removalEmptyLibsMessage}}
  </div>

  <div *ngIf="!removalEmptyLibsMessage" class="col-12">
    <div class="col-12 p-0">
      <label *ngIf="!(libraryCount > 1)">The following library will be removed: </label>
      <label *ngIf="(libraryCount > 1)">The following {{libraryCount}} libraries will be removed: </label>
    </div>
    <div class="col-12" style="max-height: 35vh; overflow-y: auto; border: 1px solid #006B96;">
      <div class="col-3" *ngFor="let lib of removalLibraryObjects">
        <label class="font-weight-bold">{{lib['libraryId']}} ({{lib['project']}})</label>
      </div>
    </div>
  </div>

  <div *ngIf="!removalEmptyLibsMessage" class="col-12">
    <label style="margin-top: 3vh;margin-bottom: 0px;">Please enter your credentials to confirm the removal action: </label>
    <fieldset  style="border: 1px solid #d6d6d6;margin-top: 10px;">
      <legend style="width: auto; font-size: inherit; font-weight: bold; margin-left: 10px;">&ensp;User Credentials&ensp;</legend>
      <div class="col-12 p-0 mt-3">
        <div class="col-12 p-0 mb-3 ml-3">
          <span class="ui-float-label">
            <input id="float-user-input" [(ngModel)]="userEmail" type="text" maxlength="100" style="width: 95%;" pInputText> 
            <label style="color: black;" for="float-user-input">User Name (PUID@domain.com)</label>
          </span>
        </div>
        <div class="col-12 p-0 mt-3 mb-3 ml-3">
          <span class="ui-float-label">
            <input id="float-user-input" [(ngModel)]="userPassword" type="password" maxlength="100" style="width: 95%;" (keyup.enter)="submitRemoval()" pInputText> 
            <label style="color: black;" for="float-user-input">User Password</label>
          </span>
        </div>
      </div>
      <div class="col-12">
        <button pButton label="Reject" class="shadow-sm float-left"
          (click)="closeRemovalSideBar()"></button>
        <button pButton label="Submit" class="shadow-sm float-right" [disabled]="isSubmitDisabled()"
          (click)="submitRemoval()"></button>
      </div>  
    </fieldset>
  </div>

  <div *ngIf="!removalEmptyLibsMessage && removelErrorReutrnMessage" class="col-12 text-center">
    <label style="font-size: large; color: red;">{{removelErrorReutrnMessage}}</label>
  </div>
</p-sidebar>

<p-sidebar [(visible)]="processViewSidebar" position="left" [autoZIndex]="true" [blockScroll]="true"
  [style]="{'width':'41em','top': '76px','padding-top': '32px','height':'91vh'}">
  <div>
    <label class="m-0">Please select one of the below options to proceed:</label>
    <div class="col-12">
      <p-radioButton name="sequencingOptionsGroup" class="mt-2 ml-2" value="complete" label="Continue the Run"
        [(ngModel)]="sequencingRunContinuationValue"></p-radioButton><br />
      <p-radioButton name="sequencingOptionsGroup" class="ml-2 mt-1" value="abort" label="Abort the Run"
        [(ngModel)]="sequencingRunContinuationValue"></p-radioButton>
    </div>
    <div>
      <label *ngIf="sequencingRunContinuationValue == 'abort'" style="margin-top: 3vh;margin-bottom: 0px;">Please enter your credentials to confirm the abortion of this run. </label>
      <fieldset *ngIf="sequencingRunContinuationValue == 'abort'" style="border: 1px solid #d6d6d6;margin-top: 10px;">
        <legend style="width: auto;font-size: inherit; font-weight: bold; margin-left: 10px">&ensp;User Credentials&ensp;</legend>
        <div class="col-12 p-0 mt-3">
          <div class="col-12 p-0 mb-3 ml-3">
            <span class="ui-float-label">
              <input id="float-user-input" [(ngModel)]="userEmail" type="text" maxlength="100" style="width: 95%;" pInputText> 
              <label style="color: black;" for="float-user-input">User Name (PUID@domain.com)</label>
            </span>
          </div>
          <div class="col-12 p-0 mt-3 mb-3 ml-3">
            <span class="ui-float-label">
              <input id="float-user-input" [(ngModel)]="userPassword" type="password" maxlength="100" style="width: 95%;" (keyup.enter)="submitRunDecisionOnSequencingCompleted()" pInputText> 
              <label style="color: black;" for="float-user-input">User Password</label>
            </span>
          </div>
        </div>
      </fieldset>
      <div class="col-12">
        <button pButton label="Submit" class="shadow-sm float-right"
          (click)="submitRunDecisionOnSequencingCompleted()"></button>
      </div>
    </div>
  </div>
</p-sidebar>

